import { PlaymodeType } from "@/enum/playmodeType.ts";
import useAudioAdapter from "@/common/hooks/useAudioAdapter.ts";
import { useSearchParamState } from "@/common/hooks/nuqs/useSearchParamState.ts";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import { audioEditor } from "@/features/AudioWorkstation/services/audio-editor.ts";

const usePlaymodeSearchParam = (): [
  PlaymodeType,
  (mode: PlaymodeType) => void
] => {
  const [audioAdapter] = useAudioAdapter();
  const [playmode, setPlaymode] = useSearchParamState(URLSearchParamKeys.PLAY_MODE);

  const changePlaymode = (mode: PlaymodeType) => {
    if (!audioAdapter || playmode === mode) {
      return;
    }

    console.log("Changing playmode to:", mode);

    audioEditor.setPlaymode(mode)
    audioAdapter.setPlaymode(mode)

    setPlaymode(mode);
  };

  return [
    (playmode || PlaymodeType.PLAYLIST) as PlaymodeType,
    changePlaymode,
  ];
};

export default usePlaymodeSearchParam;
